module.exports = __webpack_public_path__ + "img/image-025.bc75589d.png";